export default __webpack_public_path__ + "Jaclyn Chasse .29d01596e6b133ce608a.png";